import React from 'react';

/**
 * Skeleton — premium shimmer placeholder. Use instead of blank/spinner states.
 *
 * Usage:
 *   <Skeleton className="h-4 w-full" />
 *   <Skeleton.Line />        // single line of text
 *   <Skeleton.Avatar />      // circular avatar
 *   <Skeleton.Card />        // card-shaped block
 *   <SkeletonStack count={3} />   // stagger-delayed stack
 */
const Skeleton = ({ className = '', style, ...rest }) => (
  <div
    className={`u-skeleton ${className}`}
    style={style}
    aria-hidden="true"
    {...rest}
  />
);

Skeleton.Line = ({ className = '' }) => (
  <Skeleton className={`h-3.5 ${className || 'w-full'}`} />
);

Skeleton.Avatar = ({ size = 40, className = '' }) => (
  <Skeleton
    className={`rounded-full ${className}`}
    style={{ width: size, height: size }}
  />
);

Skeleton.Card = ({ className = 'h-40 w-full' }) => (
  <Skeleton className={`rounded-xl ${className}`} />
);

export const SkeletonStack = ({ count = 3, className = '' }) => (
  <div className={`space-y-3 ${className}`}>
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="flex gap-3 items-start">
        <Skeleton.Avatar size={36} />
        <div className="flex-1 space-y-2">
          <Skeleton.Line className="w-1/3" />
          <Skeleton.Line className="w-full" />
          <Skeleton.Line className="w-2/3" />
        </div>
      </div>
    ))}
  </div>
);

export default Skeleton;
